<p-dialog
  [visible]="showErrorPopup()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div
        class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="setHidePopup()"
      ></div>

      <i class="fa fa-exclamation-triangle p-error text-7xl mt-5"></i>

      @for (error of allValidationErrors(); track error) {
        <h4 class="text-lg mb-2 my-5">
          {{ error.length > 150 ? (error | slice: 0 : 150) + '..' : error }}
        </h4>
      }
    </div>
    <!-- Content -->

    <div
      class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
    >
      <p-button
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        styleClass="p-button-text text-sm"
        (click)="setHidePopup()"
      />
      <p-button
        [label]="'common.BUTTONS.BTN_CONTINUE' | translate"
        styleClass="p-button-danger text-sm"
        (click)="setHidePopup()"
      />
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
